import IconSvg from 'src/components/common/ui/IconSvg';
import MultiversClaimBtn from './MultiversClaimBtn';
import MultiversEnterBtn from './MultiversEnterBtn';

export type CardStatus = 'Done' | 'To Do' | 'claimable';
interface Props {
  status: CardStatus;
  bgImage: string;
  pointsToEarn: string;
  phase: string;
  title: string;
  description: string;
  slug: string; // Add slug to identify the card
  onEnter: (slug: string) => void; // Pass slug to handle the click
  onClaim: (slug: string) => void;
  isClaimed?: boolean;
}

export default function MultiversPointsCard({
  status,
  bgImage,
  phase,
  title,
  description,
  slug,
  pointsToEarn,
  onEnter,
  onClaim,
  isClaimed,
}: Props) {
  return (
    <div className="p-5 rounded-md bg-grayscale-800">
      <div
        className="h-[271px] w-full p-4 mb-5"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div
          className={`py-2 px-[15px] rounded-md mb-3 flex gap-1.5 items-center border w-fit ${
            status === 'To Do'
              ? 'bg-system-warning-dark border-system-warning'
              : 'bg-system-success-dark border-system-success'
          }`}
        >
          <IconSvg
            icon={status === 'To Do' ? 'comingSoonS' : 'liveS'}
            className={status === 'To Do' ? 'text-system-warning' : 'text-system-success'}
          />
          <span className="text-sm capitalize text-grayscale-100">{status}</span>
        </div>
      </div>

      <div className="mb-2.5">
        <div className="mb-1 text-xs text-grayscale-400">{phase}</div>
        <h4 className="text-lg text-brand-primary-light">{title}</h4>
      </div>

      <p className="text-sm text-grayscale-400 h-[17.2vh] overflow-hidden">{description}</p>

      <div className="border-t-2 border-grayscale-700 my-[17px]"></div>

      <div className="flex items-center justify-between">
        <div className="space-y-[5px]">
          <div className="text-sm text-grayscale-400">Points to earn</div>
          <div className="text-grayscale-100">{pointsToEarn}</div>
        </div>

        {!isClaimed && status === 'To Do' && <MultiversEnterBtn onClick={() => onEnter(slug)} />}

        {!isClaimed && status === 'claimable' && (
          <MultiversClaimBtn status="claimable" onClick={() => onClaim(slug)} />
        )}

        {isClaimed && (
          <MultiversClaimBtn
            status="claimed"
            onClick={() => {
              console.log('MultiversClaimBtn -> isClaimed');
            }}
          />
        )}
      </div>
    </div>
  );
}
